<template>
  <div>
    <!-- 该页面用来处理微信端的localStorage -->
  </div>
</template>

<script type="text/javascript">
import { removeWeChatUserAuthInfo } from '@/utils/cache'
export default {
  components: {},
  data() {
    return {}
  },
  mounted() {
    alert('开始清理!')
    removeWeChatUserAuthInfo()
    localStorage.removeItem('Web-User-Info')
    localStorage.removeItem('WeChat-User-Info')
    localStorage.removeItem('loglevel:webpack-dev-server')
    alert('清理成功!')
  }
}
</script>

<style lang="scss" scoped>
</style>
